import './Contact.scss';
import { useState } from 'react';
import emailjs from '@emailjs/browser';
import Spinner from '../components/spinner/Spinner';
import { handleViewport } from 'react-in-viewport';
import ContactAnimation from '../components/contact-animation/ContactAnimation';

function MyContact(props) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: ""
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submittedError, setSubmittedError] = useState(false);
  const [showSpinner, setShowSpinne] = useState(false);
  const { inViewport, forwardedRef } = props;

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    if (name === 'firstName' || name === 'lastName') {
      validateName(value, name);
    }
    if (name === 'email') {
      validateEmail(value);
    }
    if (name === 'phoneNumber') {
      validatePhoneNumber(value);
    }
    if (name === 'message') {
      validateMessage(value);
    }
  }

  function validateName(value, name) {
    const newErrors = Object.assign({}, errors);
    if (!value) {
      newErrors[name] = "Dit veld is verplicht";
    } else {
      newErrors[name] = "";
    }

    setErrors(newErrors);
  }


  function validateMessage(value) {
    const newErrors = Object.assign({}, errors);
    if (!value) {
      newErrors.message = "Dit veld is verplicht";
    } else {
      newErrors.message = "";
    }

    setErrors(newErrors);
  }

  function validateEmail(value) {
    const newErrors = Object.assign({}, errors);
    const validEmail = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$');

    if (!value) {
      newErrors.email = "Dit veld is verplicht";
    } else if (!validEmail.test(value)) {
      newErrors.email = "Vul een correct e-mailadres in";
    } else {
      newErrors.email = "";
    }

    setErrors(newErrors);
  }

  function validatePhoneNumber(value) {
    const newErrors = Object.assign({}, errors);
    const validPhone = new RegExp(`^((\\+31)|(0031)|0)(\\(0\\)|)(\\d{1,3})(\\s|\\-|)(\\d{8}|\\d{4}\\s\\d{4}|\\d{2}\\s\\d{2}\\s\\d{2}\\s\\d{2})$`);

    if (!value) {
      newErrors.phoneNumber = "Dit veld is verplicht";
    } else if (!validPhone.test(value)) {
      newErrors.phoneNumber = "Vul een correct telefoonnummer in";
    } else {
      newErrors.phoneNumber = "";
    }

    setErrors(newErrors);
  }

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!formData.firstName) {
      newErrors.firstName = "Dit veld is verplicht";
      isValid = false;
    }

    if (!formData.lastName) {
      newErrors.lastName = "Dit veld is verplicht";
      isValid = false;
    }

    if (!formData.email) {
      newErrors.email = "Dit veld is verplicht";
      isValid = false;
    }

    if (!formData.phoneNumber) {
      newErrors.phoneNumber = "Dit veld is verplicht";
      isValid = false;
    }

    if (!formData.message) {
      newErrors.message = "Dit veld is verplicht";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      setShowSpinne(true);
      sendEmail(e.target);
    } else {
    }
  };

  function sendEmail(form) {
    let templateParams = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      message: formData.message
    };

    emailjs
      .send(
        'service_1jisa99',
        'template_jm81hbf',
        templateParams,
        '8MdLq9JnDOBJzjTZt'
      )
      .then(
        (result) => {
          setSubmitted(true);
          setShowSpinne(false);
          resetForm(form);
        },
        (error) => {
          setSubmittedError(true);
          setShowSpinne(false);
        }
      );
  }

  function resetForm(form) {
    form.reset();
    setFormData(Object.assign({}, {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      message: ""
    }));
  }

  return (
    <section className="contact" ref={forwardedRef}>
      <div className="anchor" id="contact"></div>
      <div className="row">
        <div className="col-xs-12 col-md-7">
          <div className="card">
            <h2>Get in touch</h2>
            <form noValidate onSubmit={handleSubmit}>
              {submitted && !submittedError && (
                <p>Thank you for your message!</p>
              )}
              <div className="form-item">
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  className="form-input"
                  placeholder="First Name"
                  onChange={handleInputChange}
                  onBlur={(e) => { handleBlur(e) }}
                  required></input>
                <label for="firstName" className="form-label">First Name</label>
                {errors.firstName && (
                  <span role="alert" className="form-error-message">
                    {errors.firstName}
                  </span>
                )}
              </div>
              <div className="form-item">
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  className="form-input"
                  placeholder="Last Name"
                  onChange={handleInputChange}
                  onBlur={(e) => { handleBlur(e) }}
                  required></input>
                <label for="lastName" className="form-label">Last Name</label>
                {errors.lastName && (
                  <span role="alert" className="form-error-message">
                    {errors.lastName}
                  </span>
                )}
              </div>
              <div className="form-item">
                <input
                  type="text"
                  id="email"
                  name="email"
                  className="form-input"
                  placeholder="Email"
                  onChange={handleInputChange}
                  onBlur={(e) => { handleBlur(e) }}
                  required></input>
                <label for="email" className="form-label">Email</label>
                {errors.email && (
                  <span role="alert" className="form-error-message">
                    {errors.email}
                  </span>
                )}
              </div>
              <div className="form-item">
                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  className="form-input"
                  placeholder="Phone number"
                  onChange={handleInputChange}
                  onBlur={(e) => { handleBlur(e) }}
                  required></input>
                <label for="phoneNumber" className="form-label">Phone number</label>
                {errors.phoneNumber && (
                  <span role="alert" className="form-error-message">
                    {errors.phoneNumber}
                  </span>
                )}
              </div>
              <div className="form-item">
                <textarea
                  id="message"
                  name="message"
                  className="form-input form-textarea"
                  placeholder="Message"
                  onChange={handleInputChange}
                  onBlur={(e) => { handleBlur(e) }}
                  required></textarea>
                <label for="message" className="form-label">Message</label>
                {errors.message && (
                  <span role="alert" className="form-error-message">
                    {errors.message}
                  </span>
                )}
              </div>
              <div className="text-right">
                <button type="submit" className='button submit-button margin-top-20' aria-label="Submit contact form">
                  {showSpinner ? <Spinner /> : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
        {inViewport &&
          <div className="col-xs-12 col-md-5 align-bottom">
            <div className="card">
              <ContactAnimation></ContactAnimation>
            </div>
          </div>
        }
      </div>
    </section>
  );
}

const Contact = handleViewport(MyContact, { rootMargin: '-1.0px' });

export default Contact;